import React from 'react'

const OpenMenu = (props) => (
    <svg width="8" height="12" viewBox="0 0 8 12" fill='none' className={props.className ? props.className : ''}
         xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 11L6.5 6L1.5 1" stroke="#1D79FB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default OpenMenu
